import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";
import { logDOM } from "@testing-library/dom";
import Sidebarpo from "./Sidebarpo";
import Select from "react-select";

const CreatePO = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);

  const [poLength, setPoLength] = useState("");

  const [clients, setClients] = useState([]);
  const [suppiler, setSupplier] = useState([]);
   const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState("");
  const user = JSON.parse(localStorage.getItem("userdata"));

  useEffect(() => {
    fetchClients();
    fetchSupplier()
  }, []);

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => {
        setClients(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };

  const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };
  const handleChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");

  };

  const templateDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/PO Template.xlsx`;
    link.download = "PO Template.xlsx";
    link.click();
  };
  const handleUpload = async () => {
    if (!file) {
      Swal.fire("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      const res = await axios.post(`${BASE_URL}/api/import-excel`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      navigate("/listpo");
      setMessage("✅ File uploaded successfully!");
handleSubmitCreateImport()
      Swal.fire(res.data.message || "PO File uploaded successfully");
    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
      Swal.fire("Upload failed!");
      setMessage("❌ File upload failed.");
      setUploading(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/get-po-data`)
      .then((response) => {
        const data = response.data;
        console.log("Alllenght",data)

      if (data.length > 0) {
        const latestId = Math.max(...data.map(item => item.id));
        setPoLength(latestId);

        console.log("Latest PO ID:add", latestId);
      }

      })
      .catch((error) => {
        console.error("Error fetching PO data:", error);
      });
  }, []);

  const [formData, setFormData] = useState({
    client_name: "",
    client_po_number: "",
    client_po_date: "",
    items_description: "",
    client_po_value: "",
    c_currency: "",
    client_delivery_date: "",
    supplier_po_number: "",
    supplier_po_value: "",
    currency: "",
    supplier_name: "",
    latest_update: "",
    pearlcon_contact: "",
    supplier_payment: "",
    supplier_delivery_date: "",
    client_payment: "",
    current_status: "",
    rfq_number: "",
    status_feedback: "",
  });

  // const handleChangeForm = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'supplier_name' && value === 'add_new') {
  //   navigate('/supplierpo'); // Redirect to supplier page
  //   return;
  // }
  //  if (name === 'client_name' && value === 'add_new') {
  //   navigate('/clientlist'); // Redirect to supplier page
  //   return;
  // }

  //   setFormData((prev) => {
  //     const updatedForm = {
  //       ...prev,
  //       [name]: value,
  //     };

  //     const clientName = updatedForm.client_name || "";
  //     const rfq = updatedForm.rfq_number || "";

  //     // Only if both fields are filled
  //     if (clientName.length >= 3 && rfq.length >= 6) {
  //       const clientCode = clientName.substring(0, 3).toUpperCase();
  //       const rfqSuffix = rfq.slice(-6);
  //       const poNumber = `${clientCode}-${poLength + 1}-${rfqSuffix}`;

  //       updatedForm.supplier_po_number = poNumber;
  //     }

  //     return updatedForm;
  //   });
  // };

 const handleChangeForm = (nameOrEvent, selectedOption) => {
  // Handle normal text/number/date inputs
  if (typeof nameOrEvent === "object" && nameOrEvent.target) {
    const { name, value } = nameOrEvent.target;

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };

      const clientName = updatedForm.client_name || "";
      const rfq = updatedForm.rfq_number || "";

      if (clientName.length >= 3 && rfq.length >= 6) {
        const clientCode = clientName.substring(0, 3).toUpperCase();
        const rfqSuffix = rfq.slice(-6);
        const poNumber = `${clientCode}-${poLength + 1}-${rfqSuffix}`;
        updatedForm.supplier_po_number = poNumber;
      }

      return updatedForm;
    });
    return;
  }

  // Handle react-select dropdowns
  const name = nameOrEvent;

  if (name === "supplier_name" && selectedOption?.value === "add_new") {
    navigate("/supplierpo");
    return;
  }

  if (name === "client_name" && selectedOption?.value === "add_new") {
    navigate("/clientlist");
    return;
  }

  setFormData((prev) => {
    const updatedForm = {
      ...prev,
      [name]: selectedOption?.value || "",
    };

    const clientName = updatedForm.client_name || "";
    const rfq = updatedForm.rfq_number || "";

    if (clientName.length >= 3 && rfq.length >= 6) {
      const clientCode = clientName.substring(0, 3).toUpperCase();
      const rfqSuffix = rfq.slice(-6);
      const poNumber = `${clientCode}-${poLength + 1}-${rfqSuffix}`;
      updatedForm.supplier_po_number = poNumber;
    }

    return updatedForm;
  });
};


  const handleSubmit = async () => {
    const sendData = new FormData();

    // Append all text fields
    Object.entries(formData).forEach(([key, value]) => {
      sendData.append(key, value);
    });

    // Append file with correct key
    if (file1) {
      sendData.append("po_attachment", file1);
    }
    try {
      const res = await axios.post(`${BASE_URL}/api/craetepodata`, sendData, {
        headers: {
          Accept: "application/json",
        },
      });
      navigate("/listpo");
      handleSubmitCreatepo()
      Swal.fire(res.data.message || "PO created successfully!");
    } catch (error) {
      console.error(
        "Error submitting PO:",
        error.response?.data || error.message
      );
      Swal.fire("Failed to submit PO");
    }
  };



   const handleSubmitCreatepo = async () => {
    try {
      const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
        {
          user_id:user.id,
          type:"PO",
          message:"New PO Created",
          status:"0"
        }
      );
      console.log(response.data);
    
    } catch (error) {
      console.error(error);
     
    }
  };


   const handleSubmitCreateImport = async () => {
    try {
      const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
        {
          user_id:user.id,
          type:"PO",
          message:"New PO Import xlsx File",
          status:"0"
        }
      );
      console.log(response.data);
    
    } catch (error) {
      console.error(error);
     
    }
  };

  return (
    <div className="row">
      <div className="custom-2-5">
        <Sidebarpo />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4 mt-4">
        <div className="card p-4 shadow">
          <div className="row">
            <div className="col-lg-9">
              <h5 className="mb-3">CREATE PO</h5>
            </div>
            <div className="col-lg-3">
              <button className="btn btncolor" onClick={templateDownload}>
                Demo Template Download
              </button>
            </div>
          </div>
          {/* <div className="row mt-4" style={{ border: "1px solid black" }}>
            <div className="col-lg-9 p-2">
              <label>
                <strong>Import xlsx File</strong>
              </label>
              <br />
              <input
                type="file"
                onChange={handleChange}
                accept=".xls,.xlsx,.csv"
              />
            </div>
            <div className="col-lg-3 p-2 mt-3">
              <button className="btn btncolor" onClick={handleUpload}>
                Upload
              </button>
            </div>
          </div> */}
           <div className="row">
            <div className="col-lg-12 p-2">
              <label>
                <strong>Import xlsx File</strong>
                <div className="accepted-formats">
                  <h6>
                    <i className="fas fa-info-circle"></i> Accepted File Formats
                  </h6>
                  <div className="format-list">
                    <span className="format-tag">.xlsx</span>
                    <span className="format-tag">.xls</span>
                    <span className="format-tag">.csv</span>
                  </div>
                </div>
              </label>
              <br />

              <div className="upload-section" id="uploadSection">
                <input
                  type="file"
                  className="file-input"
                  id="fileInput"
                  accept=".xls,.xlsx,.csv"
                  onChange={handleChange}
                />
                <div className="upload-icon">
                  <i className="fas fa-cloud-upload-alt"></i>
                </div>
                <div className="upload-text">
                  <strong>Click to upload</strong> or drag and drop
                </div>
                <div className="upload-subtext">Maximum file size: 10MB</div>
              </div>

              {file && (
                <div className="file-info mt-2">
                  <div className="file-name">{file.name}</div>
                  <div className="file-size">
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </div>
                </div>
              )}

              {message && <div className="mt-2">{message}</div>}

             <div className="mt-3 d-flex justify-content-end">
  <button
    className="btn btncolor end-text"
    onClick={handleUpload}
    disabled={!file || uploading}
  >
    {uploading ? "Uploading..." : "Upload"}
  </button>
</div>
            </div>
          </div>

          <h2 className="text-center my-4">OR</h2>

          <div className="row">
            <div className="form-group mb-3 col-lg-4">
                <label>
                  <strong>POAttachment</strong>
                </label>
                <br />
                <input
                  type="file"
                  onChange={(e) => setFile1(e.target.files[0])}
                />
                        
              </div>
           {/* <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Client Name*</strong>
              </label>
              <select
                name="client_name"
                className="form-control"
                value={formData.client_name}
                onChange={handleChangeForm}
              >
                <option value="">Select Client</option>
                {clients.map((client, index) => (
                  <option key={index} value={client.client_name}>
                    {client.client_name}
                  </option>
                ))}

                <option value="add_new">
                  
                  <button className="btn btn-primary">New Add</button>
               
                </option>
              </select>
            </div> */}
            <div className="form-group mb-3 col-lg-4">
      <label>
        <strong>Client Name*</strong>
      </label>
      <Select
        name="client_name"
        value={
          formData.client_name
            ? { label: formData.client_name, value: formData.client_name }
            : null
        }
        onChange={(selectedOption) =>
          handleChangeForm("client_name", selectedOption)
        }
        options={[
          ...clients.map((c) => ({
            label: c.client_name,
            value: c.client_name,
          })),
          { label: "➕ Add New Client", value: "add_new" },
        ]}
        placeholder="Search or select client"
        isSearchable
        classNamePrefix="react-select"
      />
    </div>
            {/* Required Fields */}
            {[
              {
                label: "Client PO Number *",
                name: "client_po_number",
                required: true,
              },
              {
                label: "Client PO Date *",
                name: "client_po_date",
                type: "date",
                required: true,
              },
            ].map(({ label, name, type = "text", required }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  required={required}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                />
              </div>
            ))}

            {/* Optional Inputs */}
            {[
              { label: "Item Description", name: "items_description" },
              {
                label: "Client PO Value",
                name: "client_po_value",
                type: "number",
              },
              
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}

 <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>  Currency</strong>
              </label>
              <select
                name="c_currency"
                className="form-control"
                value={formData.c_currency}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="GBP">GBP</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="SAR">SAR</option>
                <option value="QD">QD</option>
                <option value="AED">AED</option>
                <option value="Other">Other</option>
              </select>
            </div>

 {[
              
              {
                label: "Client Delivery Date",
                name: "client_delivery_date",
                type: "date",
              },
              {
                label: "Supplier PO Number",
                name: "supplier_po_number",
                readOnly: true,
              }, // ⬅️ updated line
              {
                label: "Supplier PO Value",
                name: "supplier_po_value",
                type: "number",
              },
              
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}
             <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Currency</strong>
              </label>
              <select
                name="currency"
                className="form-control"
                value={formData.currency}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="GBP">GBP</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="SAR">SAR</option>
                <option value="QD">QD</option>
                <option value="AED">AED</option>
                <option value="Other">Other</option>
              </select>
            </div>


            {/* <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Supplier Name</strong>
              </label>
              <select
                name="supplier_name"
                className="form-control"
                value={formData.supplier_name}
                onChange={handleChangeForm}
              >
                <option value="">Select Supplier</option>
                {suppiler.map((client, index) => (
                  <option key={index} value={client.name}>
                    {client.name}
                  </option>
                ))}
                <option value="add_new">
                  
                  <button className="btn btn-primary">New Add</button>
               
                </option>
              </select>
       
            </div> */}

            {/* <div className="form-group mb-3 col-lg-4">
      <label>
        <strong>Supplier Name</strong>
      </label>
      <Select
        name="supplier_name"
        value={
          formData.supplier_name
            ? { label: formData.supplier_name, value: formData.supplier_name }
            : null
        }
        onChange={(selectedOption) =>
          handleChangeForm("supplier_name", selectedOption)
        }
        options={[
          ...suppiler.map((s) => ({
            label: s.name,
            value: s.name,
          })),
          { label: "➕ Add New Supplier", value: "add_new" },
        ]}
        placeholder="Search or select supplier"
        isSearchable
        classNamePrefix="react-select"
      />
    </div> */}

             {[
             
             
              { label: "Supplier Name", name: "supplier_name" },
              { label: "Pearlcon Contact", name: "pearlcon_contact" },
              {
                label: "Supplier Delivery Date",
                name: "supplier_delivery_date",
                type: "date",
              },
              { label: "Current Status", name: "current_status" },
              { label: "RFQ Number", name: "rfq_number" },
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}

            {/* Dropdown Fields */}
           

           

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Latest Update</strong>
              </label>
              <select
                name="latest_update"
                className="form-control"
                value={formData.latest_update}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Po Received From Client">
                  Po Received From Client
                </option>
                <option value="Po issued to supplier">
                  Po issued to supplier
                </option>
                <option value="Po Under Progress">Po Under Progress</option>
                <option value="Po Shipped">Po Shipped</option>
                <option value="Commercial Invoice Issue">Commercial Invoice Issue</option>
                <option value="Payment Invoice Issue">Payment Invoice Issue</option>
                <option value="Payment Received">Payment Received</option>
                <option value="Po Closed">Po Closed</option>
              </select>
            </div>

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Supplier Payment</strong>
              </label>
              <select
                name="supplier_payment"
                className="form-control"
                value={formData.supplier_payment}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Advance With Order">Advance With Order</option>
                <option value="Advance Before Dispatch">
                  Advance Before Dispatch
                </option>
                <option value="OnCredit">OnCredit</option>
                <option value="Stage Payment">Stage Payment</option>
              </select>
            </div>
            {formData.supplier_payment === "Stage Payment" && (
              <div className="form-group mb-3 col-lg-4">
                <label>
                  <strong>Curent Remark</strong>
                </label>
                <input
                  type="text"
                  name="status_feedback"
                  className="form-control"
                  value={formData.status_feedback || ""}
                  onChange={handleChangeForm}
                />
              </div>
            )}

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Client Payment</strong>
              </label>
              <select
                name="client_payment"
                className="form-control"
                value={formData.client_payment}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Payment Pending">Payment Pending</option>
                <option value="Payment Received">Payment Received</option>
                <option value="Payment Delayed">Payment Delayed</option>
              </select>
            </div>
          </div>

          <div className="text-center">
            <button className="btn btncolor w-50 mt-3" onClick={handleSubmit}>
              Submit PO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePO;
